import styled from 'styled-components';

export const TestTypeOptionWrapper = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`;

export const TestTypeLabelStyled = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 252px;
`;

export const TestTypeNameStyled = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const TestTypeDescriptionStyled = styled(TestTypeNameStyled)`
  font-size: 12px;
  color: var(--ds-text-subtlest, var(--ds-fb-text-subtlest));
`;

export const TestTypeOptionIconStyled = styled.div<{
  backgroundColor: string;
}>`
  background-color: ${(props) => props.backgroundColor};
  border-radius: 24px;
  height: 24px;
  width: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
